<template>
  <el-dialog title="修改手机号"
             :visible.sync="dialogVisible"
             width="400px"
             custom-class="modify-phone-dia"
             :show-close="false"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :before-close="handleClose">
    <div class="content">
      <!-- <div class="label">手机号</div>
      <el-input placeholder="请输入"
                v-model="doctor_phone"
                clearable
                size="small">
      </el-input> -->

      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="手机号"
                      prop="doctor_phone">
          <el-input placeholder="请输入"
                    v-model="ruleForm.doctor_phone"
                    clearable
                    size="small">
          </el-input>
        </el-form-item>

      </el-form>

    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 @click="cancelBtn">取 消</el-button>
      <el-button type="primary"
                 size="small"
                 @click="confirmBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import common from '@/api/common.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      require: true
    },
    doctor_id: {
      type: [String, Number],
      require: true
    },
    phone: {
      type: [String, Number],
      require: true
    }
  },
  data() {
    const validatorPhone = (rule, value, callback) => {
      let testPhone = /^1[3-9]\d{9}$/;
      if (this.ruleForm.doctor_phone.trim() === '') {
        return callback(new Error('请输入手机号'));
      } else if (!testPhone.test(value)) {
        return callback('请输入正确的手机号');
      } else {
        return callback();
      }
    };
    return {
      ruleForm: {
        doctor_phone: this.phone
      },
      rules: {
        doctor_phone: [
          { required: true, validator: validatorPhone, trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    dialogVisible: {
      handler: function (n) {
        if (n) {
          this.$nextTick(() => {
            this.$refs['ruleForm'].resetFields();
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:dialogVisible', false);
    },
    cancelBtn() {
      this.$emit('update:dialogVisible', false);
    },
    confirmBtn() {
      let params = {
        doctor_id: this.doctor_id,
        doctor_phone: this.ruleForm.doctor_phone
      };

      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          common.updateDoctorPhone(params).then((res) => {
            let { code, data } = res;
            if (code === 0) {
              this.$emit('update:dialogVisible', false);
              this.$emit('getDetail');
              this.$message.success('修改成功');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.modify-phone-dia {
  .content {
    display: flex;
    align-items: center;
    padding: 10px;
    .label {
      width: 60px;
    }
  }
}
</style>